/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { IDetailsListProps, IColumn, SelectionMode, ConstrainMode } from '@fluentui/react/lib/DetailsList';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IUserProfile } from '../../../Auth/types';
import { confirmDialog, showDialog, showToastMessage } from '../../../Dialog/actions';
import Constants from '../../../../core/libraries/Constants';
import RbLabel, { LabelSize } from '../../../../bosch-react/components/label/RbLabel';
import RbButton, { ButtonSize, ButtonType } from '../../../../bosch-react/components/button/RbButton';
import Table from '../../../../core/components/Table';
import { RootState } from '../../../../store/store';
import Helper from '../../../../core/libraries/Helper';
import { IDivision } from './types';
import { IconButton, IListProps, Panel, ShimmeredDetailsList, TooltipHost } from '@fluentui/react';
import RbTextField from '../../../../bosch-react/components/text-field/RbTextField';
import { getDivisionsList } from '../../../../services/commonServices';
import Color from '../../../../core/libraries/Color';
import { addDivision, deleteDivision, exportDivAdmins, exportDocumentsInDiv } from '../../services';
import RbLoadingSpinner from '../../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import Configuration from '../../../../core/libraries/Configuration';
import DetailsListWrapper from '../../../../core/components/DetailsListWrapper/DetailsListWrapper';
import { tooltipHostStyles } from '../types';

interface DivisionsProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
}

interface IState {
    isShowNewDivision: boolean,
    divisions: IDivision[] | null,
    newDiv: IDivision | undefined,
    error: IDivision | undefined,
    isValidForm: boolean,
    isProcessing: boolean,
}

class Divisions extends React.Component<DivisionsProps, IState> {

    constructor(props: DivisionsProps) {
        super(props);

        this.state = {
            isShowNewDivision: false,
            divisions: null,
            newDiv: undefined,
            error: undefined,
            isValidForm: false,
            isProcessing: false
        };
        this.loadList = this.loadList.bind(this);
        this._renderItemColumn = this._renderItemColumn.bind(this);
        this._onSaveDivision = this._onSaveDivision.bind(this);
        this._exportDivisionsAdministrators = this._exportDivisionsAdministrators.bind(this);
    }

    async componentDidMount() {
        this.checkValidForm()
        if (!this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {
            /* Access Dialog */
            this.props.confirmDialog(
                Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
                Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
                true,
                () => {
                    window.location.href = "/";
                }
            );
        }
        else {
            await this.handelGetAllDivisions();
        }
    }

    columns: IColumn[] = [
        {
            key: 'title',
            name: 'Title',
            fieldName: 'Title',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IDivision) => {
                return (<RbLabel size={LabelSize.Small} >{item.title}</RbLabel>);
            }
        },
        {
            key: 'longTitle',
            name: 'Long Title',
            fieldName: 'LongTitle',
            currentWidth: Helper.resizeColumnByScreenWidth(30),
            minWidth: Helper.resizeColumnByScreenWidth(30),
            isResizable: true,
            onRender: (item: IDivision) => {
                return (<RbLabel size={LabelSize.Small} >{item.longTitle}</RbLabel>);
            }
        },
        {
            key: 'action',
            name: 'Action',
            fieldName: 'Action',
            currentWidth: Helper.resizeColumnByScreenWidth(30),
            minWidth: Helper.resizeColumnByScreenWidth(30),
            isResizable: true,
            onRender: (item: IDivision) => {
                return (
                    <span>
                        <RbButton disabled={this.state.isProcessing === true} type={ButtonType.Secondary} size={ButtonSize.Tiny} label="Remove" onClick={() => { this._confirmDeletion(item) }} />
                        &nbsp;
                        <RbButton disabled={this.state.isProcessing === true} type={ButtonType.Secondary} size={ButtonSize.Tiny} label="Export" onClick={() => { !!item.title && this._exportMetadata(item.title) }} />
                    </span>
                );
            }
        }
    ];

    NewDivisionTemplate(label: string, field: any, error: string, isRequire: boolean = false) {
        return (
            <div >
                <RbLabel>{label}{isRequire && (<span style={{ color: Color.RED }}>*</span>)}</RbLabel>
                {field}
                {error !== "" && <RbLabel style={{ color: Color.RED }} size={LabelSize.Small}>{error}</RbLabel>}
            </div>
        );
    }

    _onDismissPanel = () => {
        this.setState({ isShowNewDivision: false })
    }

    checkValidForm = () => {
        let error: IDivision = {};
        let isValid = true;
        if (!!this.state.newDiv?.title === false) {
            error.title = "Title could not be empty";
            isValid = false;
        }
        if (!!this.state.newDiv?.longTitle === false) {
            error.longTitle = "Long title could not be empty";
            isValid = false;
        }
        const isExisted = this.state.divisions?.some(item => item.title?.toLowerCase() === this.state.newDiv?.title?.toLowerCase())
        if (isExisted) {
            error.title = "Your input already exists.";
            isValid = false;
        }
        this.setState({
            error: error,
            isValidForm: isValid
        })
    }

    _onSaveDivision = async () => {
        this.setState({ isShowNewDivision: false, isProcessing: true }, async () => {
            const success = !!this.state.isValidForm && await addDivision(this.state.newDiv!);
            !!success && this.handelGetAllDivisions();
            this.setState({ isProcessing: false })
            this.props.showToastMessage(!!success && "success" || "error", !!success && "Add successfully" || "Failed to add new division")
        })
    }

    handelGetAllDivisions = async () => {
        this.setState({ divisions: [] })
        const getDivsResponse = await getDivisionsList();
        const allDivisions = getDivsResponse.data as IDivision[];
        !!allDivisions && allDivisions.length > 0 && this.setState({
            divisions: allDivisions
        })
    }
    _onShowPanel = () => {
        this.setState({ isShowNewDivision: true })
    }

    _onRenderFooterContent = () => {
        return <div>
            <RbButton disabled={this.state.isValidForm === false} size={ButtonSize.Small} onClick={this._onSaveDivision} type={ButtonType.Primary} label='Save' />
            <RbButton size={ButtonSize.Small} onClick={this._onDismissPanel} type={ButtonType.Secondary} label='Cancel' />
        </div>
    }
    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };

    render() {
        let element: any = "";
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {
            element = (
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm1" />
                        <div className="ms-Grid-col ms-sm10">

                            <div className="ms-Grid">
                                <div className="ms-Grid-row">
                                    <RbLabel className="header-title" size={LabelSize.Large} >Divisions</RbLabel>
                                    <TooltipHost
                                        content={"the list of division is loaded from the list DivisionMaster"}
                                        styles={tooltipHostStyles}
                                        calloutProps={{ gapSpace: 10 }}
                                    >
                                        <IconButton
                                            iconProps={{ iconName: "Info" }}
                                            ariaLabel="Tab information"
                                            title="Tab information"
                                        />
                                    </TooltipHost>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid">
                                        {/* Button "New division" */}
                                        {this.state.isProcessing && <RbLoadingSpinner /> || <div className="ms-Grid-row common-padding-row">
                                            <RbButton label="New division" size={ButtonSize.Small} onClick={this._onShowPanel} />
                                            <RbButton label="Export all division administrators" size={ButtonSize.Small} onClick={this._exportDivisionsAdministrators} />
                                        </div>}
                                        {/* List of Divisions */}
                                        {/* <Table detailsListProps={detailsListProps} height={60}></Table> */}
                                        <DetailsListWrapper>
                                            <ShimmeredDetailsList
                                                setKey="set"
                                                compact={true}
                                                items={this.state.divisions || []}
                                                constrainMode={ConstrainMode.unconstrained}
                                                columns={this.columns}
                                                selectionMode={SelectionMode.single}
                                                enableShimmer={!this.state.divisions}
                                                ariaLabelForShimmer="Content is being fetched"
                                                ariaLabelForGrid="Pending order details"
                                                listProps={this.shimmeredDetailsListProps}
                                                onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                                                onShouldVirtualize={() => { return true }}
                                            />
                                        </DetailsListWrapper>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="ms-Grid-col ms-sm1" />
                    </div>
                    {/* Add New Division */}
                    <Panel
                        headerText="Hey, which Division would you like to add?"
                        // this prop makes the panel non-modal
                        isBlocking={false}
                        isOpen={this.state.isShowNewDivision}
                        onDismiss={this._onDismissPanel}
                        onRenderFooter={this._onRenderFooterContent}
                        closeButtonAriaLabel="Close"
                        isFooterAtBottom={true}
                    >
                        <br />
                        <br />
                        {this.NewDivisionTemplate(
                            "Title",
                            <RbTextField placeholder="Example: BD" ref={this.state.newDiv?.title} value={this.state.newDiv?.title || ""}
                                onChange={(event) => {
                                    this.setState((prevState: IState) => ({
                                        newDiv: {
                                            ...prevState.newDiv, // Spread the previous newDiv object to keep other properties
                                            title: event.target.value // Update the 'name' property
                                        }
                                    }), () => {
                                        this.checkValidForm()
                                    });

                                }} />,
                            this.state.error?.title ?? "",
                            true
                        )}
                        <br />
                        {this.NewDivisionTemplate(
                            "Long Title",
                            <RbTextField placeholder="Example: Bosch Digital" ref={this.state.newDiv?.longTitle} value={this.state.newDiv?.longTitle || ""}
                                onChange={(event) => {
                                    this.setState((prevState: IState) => ({
                                        newDiv: {
                                            ...prevState.newDiv,
                                            longTitle: event.target.value
                                        }
                                    }), () => {
                                        this.checkValidForm();
                                    });
                                }} />,
                            this.state.error?.longTitle ?? "",
                            true
                        )}
                    </Panel>
                </div>
            );
        }
        return element;
    }

    _renderItemColumn(item: any, index: number | undefined, column: any) {
        let content: any = "";
        switch (column.key) {
            case "action": {
                content =
                    <span>
                        <RbButton disabled={this.state.isProcessing === true} type={ButtonType.Secondary} size={ButtonSize.Tiny} label="Remove" onClick={() => { this._confirmDeletion(item) }} />
                        &nbsp;
                        <RbButton disabled={this.state.isProcessing === true} type={ButtonType.Secondary} size={ButtonSize.Tiny} label="Export" onClick={() => { this._exportMetadata(item.title) }} />
                    </span>;
                break;
            }
            default: {
                content = <span>{item[column.fieldName]}</span>;
                break;
            }
        }
        return content;
    }

    loadList() {
    }

    handleDeleteDivision = async (divId: number) => {
        this.setState({ isProcessing: true }, async () => {
            const success = await deleteDivision(divId);
            !!success && this.handelGetAllDivisions();
            this.setState({ isProcessing: false })
            this.props.showToastMessage(!!success && "success" || "error", !!success && "Removed successfully" || "Failed to remove division")
        })
    }

    _confirmDeletion(divItem: any) {
        this.props.confirmDialog("Remove division", `Do you want delete ${divItem.title}?`, false, () => {
            this.handleDeleteDivision(divItem.id)
        })
    }

    _exportMetadata = async (divTitle: string) => {
        this.setState({ isProcessing: true }, async () => {
            const success = await exportDocumentsInDiv(divTitle);
            this.setState({ isProcessing: false })
            this.props.showToastMessage(!!success && "success" || "error", !!success && "Exported successfully. You will see the Excel file in your downloads." || "Failed to export")
        })
    }

    _exportDivisionsAdministrators = async () => {
        this.setState({ isProcessing: true }, async () => {
            const success = await exportDivAdmins();
            this.setState({ isProcessing: false })
            this.props.showToastMessage(!!success && "success" || "error", !!success && "Exported successfully. You will see the Excel file in your downloads." || "Failed to export")
        })
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps, {
    confirmDialog,
    showDialog,
    showToastMessage,
})(Divisions);